













import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import MicroEntryVerificationAccountElement from "./MicroEntryVerificationAccountElement.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";

@Component({
  components: {
    MicroEntryVerificationAccountElement
  }
})

export default class MicroEntryVerificationAccountList extends Vue {
  isEditing = false;

  @Prop()
  disabled: boolean;

  bankAccountStore = useBankAccountStore();

  get buttonsAreDisabled () {
    return this.isEditing || this.disabled;
  }

  onEditButtonClicked (isEditing: boolean) {
    this.isEditing = isEditing;
  }
}
